export default {
  name: "MechanicalArmPoseRender",
  props: {
    data: {
      type: Object,
      default: () => null
    },
    review: {
      type: Object,
      default: () => null
    },
    reviewMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      letters: ["A", "B", "C", "D", "E", "F", "G", "H"],
      selectedAnswer: null,
      assetError: false
    };
  },
  computed: {
    assetsReady() {
      return !this.assetError;
    }
  },
  watch: {
    data() {
      this.resetSelection();
    },
    review() {
      this.resetSelection();
    },
    reviewMode() {
      this.resetSelection();
    }
  },
  methods: {
    resetSelection() {
      this.selectedAnswer = this.reviewMode ? this.review?.answer || null : null;
      if (!this.reviewMode) {
        this.$emit('answer', null);
      }
    },
    markFailed() {
      this.assetError = true;
      this.selectedAnswer = null;
      if (!this.reviewMode) {
        this.$emit('answer', null);
      }
    },
    directionText(direction) {
      return direction === 'WITH_ARROW' ? '顺着箭头' : '逆着箭头';
    },
    selectAnswer(letter) {
      if (this.reviewMode || !this.assetsReady) {
        return;
      }
      this.selectedAnswer = letter;
      this.$emit('answer', letter);
    },
    buttonClass(letter) {
      if (!this.reviewMode) {
        return {
          selected: this.selectedAnswer === letter
        };
      }
      return {
        correct: this.data?.rightAnswer === letter,
        wrong: this.review?.answer === letter && this.data?.rightAnswer !== letter
      };
    }
  },
  mounted() {
    this.resetSelection();
  }
};